export default __webpack_public_path__ + "static/media/web_dev.da116896.png";